var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineArrowLeft2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.41 18.34-4.63-2.67c-1.63-.95-2.53-2.25-2.53-3.67s.9-2.72 2.53-3.66l4.63-2.67c1.63-.94 3.2-1.07 4.44-.36 1.23.71 1.91 2.14 1.91 4.02v5.34c0 1.88-.68 3.31-1.91 4.02-.53.31-1.12.46-1.75.46-.84 0-1.76-.27-2.69-.81zm.75-11.37L8.53 9.64c-1.15.66-1.78 1.5-1.78 2.36 0 .86.63 1.7 1.78 2.36l4.63 2.67c1.15.66 2.19.79 2.94.36.75-.43 1.16-1.4 1.16-2.72V9.33c0-1.32-.41-2.29-1.16-2.72-.3-.17-.64-.25-1-.25-.58 0-1.24.2-1.94.61z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineArrowLeft2);
export default __webpack_public_path__ + "static/media/vuesax-outline-arrow-left_2.abe99c6de07786691bbf27d4950fa834.svg";
export { ForwardRef as ReactComponent };